import React from 'react';
import { Tooltip } from '@patternfly/react-core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-mobx-router5';

import { LandingLayout } from 'components/Landing/LandingLayout';

type SidebarButtonsProps = {
  pathCode: string;
  showCustomizeButton: boolean;
  showDeleteButton: boolean;
  isJoined: boolean;
  isEnrolling: boolean;
  isReadOnly?: boolean;
  onEnroll: () => void;
  onUnenroll: () => void;
  onDeleteClick: () => void;
};

const SidebarButtons = ({
  pathCode,
  showCustomizeButton,
  showDeleteButton,
  isJoined,
  isEnrolling,
  isReadOnly = false,
  onEnroll,
  onUnenroll,
  onDeleteClick,
}: SidebarButtonsProps) => {
  const { t } = useTranslation();

  const handleEnrollClick = () => {
    if (isJoined) {
      onUnenroll();
    } else {
      onEnroll();
    }
  };

  const enrollDisabled = isEnrolling || isReadOnly;
  const enrollButton = (
    <LandingLayout.SidebarButton
      variant={isJoined ? 'secondary' : 'primary'}
      isBlock
      onClick={handleEnrollClick}
      isLoading={isEnrolling}
      isDisabled={enrollDisabled}
      data-analytics-id={
        isJoined
          ? 'unenroll-btn-skills-path-landing-lp'
          : 'enroll-btn-skills-path-landing-lp'
      }
    >
      {isJoined ? t('Unenroll') : t('Enroll')}
    </LandingLayout.SidebarButton>
  );

  return (
    <>
      {isReadOnly ? (
        <Tooltip
          content={t(
            'This skills path is not accessible under your current subscription.',
          )}
          position="top"
        >
          <span>{enrollButton}</span>
        </Tooltip>
      ) : (
        enrollButton
      )}

      {showCustomizeButton && (
        <Link
          href
          routeName="custom-skill-path-edit"
          routeParams={{ code: pathCode }}
        >
          <LandingLayout.SidebarButton
            variant="secondary"
            isBlock
            data-analytics-id="customize-btn-skills-path-landing-lp"
          >
            {t('Customize')}
          </LandingLayout.SidebarButton>
        </Link>
      )}

      {showDeleteButton && (
        <LandingLayout.SidebarButton
          isCancel
          variant="danger"
          isBlock
          onClick={onDeleteClick}
          data-analytics-id="delete-btn-skills-path-landing-lp"
        >
          {t('Delete')}
        </LandingLayout.SidebarButton>
      )}
    </>
  );
};

export default SidebarButtons;
